// Export utilities: STL, OBJ, JSON. PNG is captured directly from the canvas.

function triangulateFace(face) {
  // fan triangulation from vertex 0
  const tris = [];
  for (let i = 1; i < face.length - 1; i++) {
    tris.push([face[0], face[i], face[i + 1]]);
  }
  return tris;
}

function cross(a, b) {
  return [
    a[1] * b[2] - a[2] * b[1],
    a[2] * b[0] - a[0] * b[2],
    a[0] * b[1] - a[1] * b[0],
  ];
}
function sub(a, b) {
  return [a[0] - b[0], a[1] - b[1], a[2] - b[2]];
}
function norm(v) {
  const l = Math.hypot(v[0], v[1], v[2]) || 1;
  return [v[0] / l, v[1] / l, v[2] / l];
}

export function toSTL(vertices, faces, radius = 1) {
  const V = vertices.map((v) => [v[0] * radius, v[1] * radius, v[2] * radius]);
  const lines = ['solid panels_ball'];
  faces.forEach((face) => {
    triangulateFace(face).forEach(([i, j, k]) => {
      const a = V[i], b = V[j], c = V[k];
      const n = norm(cross(sub(b, a), sub(c, a)));
      lines.push(`facet normal ${n[0]} ${n[1]} ${n[2]}`);
      lines.push('  outer loop');
      lines.push(`    vertex ${a[0]} ${a[1]} ${a[2]}`);
      lines.push(`    vertex ${b[0]} ${b[1]} ${b[2]}`);
      lines.push(`    vertex ${c[0]} ${c[1]} ${c[2]}`);
      lines.push('  endloop');
      lines.push('endfacet');
    });
  });
  lines.push('endsolid panels_ball');
  return lines.join('\n');
}

export function toOBJ(vertices, faces, radius = 1) {
  const lines = ['# Panels Studio export', 'o PanelsBall'];
  vertices.forEach((v) => {
    lines.push(`v ${v[0] * radius} ${v[1] * radius} ${v[2] * radius}`);
  });
  faces.forEach((face) => {
    // OBJ face indices are 1-based
    lines.push('f ' + face.map((i) => i + 1).join(' '));
  });
  return lines.join('\n');
}

export function toJSON(design) {
  return JSON.stringify(design, null, 2);
}

export function downloadText(filename, text, mime = 'text/plain') {
  const blob = new Blob([text], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function downloadDataURL(filename, dataURL) {
  const a = document.createElement('a');
  a.href = dataURL;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
